import { createAction } from '@reduxjs/toolkit';
import { RecordOf } from 'immutable';
import { getPayloadCreator } from '../core/actionHelpers';
import { AuthSelectDatasetPayloadProps, AuthStoreProps, AuthTokenDataProps, ExchangeRefreshToken } from './authTypes';

export const authLogin = createAction('AUTH_LOGIN', getPayloadCreator());
export const authLogout = createAction('AUTH_LOGOUT', getPayloadCreator<{ reason?: string }>());

export const getOAuthToken = createAction('AUTH_GET_OAUTH_TOKEN', getPayloadCreator<string>());
export const getOAuthTokenSuccess = createAction(
  'AUTH_GET_OAUTH_TOKEN_SUCCESS',
  getPayloadCreator<RecordOf<AuthTokenDataProps>>(),
);
export const getOAuthTokenFailure = createAction('AUTH_GET_OAUTH_TOKEN_FAILURE', getPayloadCreator<any>());

export const exchangeRefreshToken = createAction(
  'EXCHANGE_REFRESH_TOKEN',
  getPayloadCreator<ExchangeRefreshToken | undefined>(),
);
export const exchangeRefreshTokenSuccess = createAction(
  'EXCHANGE_REFRESH_TOKEN_SUCCESS',
  getPayloadCreator<RecordOf<AuthTokenDataProps>>(),
);
export const exchangeRefreshTokenFailure = createAction('EXCHANGE_REFRESH_TOKEN_FAILURE', getPayloadCreator<string>());

export const updateAuth = createAction('AUTH_UPDATE', getPayloadCreator<AuthStoreProps>());

export const invalidateAccessToken = createAction('INVALIDATE_ACCESS_TOKEN', getPayloadCreator());
export const invalidateRefreshToken = createAction('INVALIDATE_REFRESH_TOKEN', getPayloadCreator());

export const authSelectDataset = createAction(
  'AUTH_SELECT_DATASET',
  getPayloadCreator<AuthSelectDatasetPayloadProps>(),
);
export const authSelectDatasetAuto = createAction(
  'AUTH_SELECT_DATASET_AUTO',
  getPayloadCreator<{ reload: boolean; location?: string | null }>(),
);

export const authUpdated = createAction(
  'AUTH_UPDATED',
  getPayloadCreator<{
    authSession: RecordOf<AuthStoreProps>;
    reload: boolean;
    location?: string;
    prevAuthSession: RecordOf<AuthStoreProps>;
  }>(),
);
export const persistAuthSession = createAction('AUTH_PERSIST_AUTH_SESSION', getPayloadCreator());
